import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import queryString from 'query-string'
import Album from './Album'
import noartwork from '../assets/noartwork.jpg'
import { CLIENT_ID } from './../constants/auth';
const apiLink = '//api.soundcloud.com/playlists/'

class Stream extends React.Component {
    constructor() {
        super();
        this.state = {
            tracks: [],
            currentTrack: null,
            isPaused: true,
            activeIndex: null,
            currentSpinner: null,
            loadedItems: [],
            allRef: null
        };
        this.spinner = React.createRef();
        this.scrollthis = React.createRef()
        this.handleClick = this.handleClick.bind(this)
        this.getTracks = this.getTracks.bind(this)
        this.keyReturn = this.keyReturn.bind(this)
        this.sendRef = this.sendRef.bind(this)
    }
    handleClick(index, track, ref) {
        const _ = (this.props.isPaused === false && track.id === this.props.currentTrack) ? ref.style['animation-play-state'] = 'paused' : ref.style['animation-play-state'] = 'running';
        this.setState({
            activeIndex: index,
            isPaused: !this.state.isPaused,
            currentSpinner: ref
        });
        this.props.handler(track.id, index);

    }
    onLoad(feedItem) {
        this.setState(({ loadedItems }) => {
            return { loadedItems: loadedItems.concat(feedItem) }
        })
    }
    getTracks(data, track) {
        this.setState({
            tracks: data.tracks.reverse(),
            currentTrack: track
        })
    }
    keyReturn(e) {
        this.props.escFunction(e, this.state.activeIndex, this.state.tracks, this.spinner.current)
    }
    sendRef(ref, key) {
        this.setState({
            allRef: ref
        })
    }
      componentDidMount() {
    }
    async componentWillMount() {
        document.title = "Cosmic Moons - " + this.props.genre;
        document.addEventListener("keydown", this.keyReturn, false);

        await fetch(apiLink + this.props.playlist + "?client_id=" + CLIENT_ID)
            .then((response) =>
                response.json())
            .then((data) => {
                const values = queryString.parse(this.props.location.search)
                this.getTracks(data,values.track);
                this.props.getTracks(this.state.tracks, values.track);
            });
            this.setState({
                currentTrack: this.props.currentTrack
            })

    };
    componentWillUnmount() {
        document.removeEventListener("keydown", this.keyReturn, false);
    }
    render() {
        return (
            <div style={{ display: 'flex', flex: 1, width: "100vw" }}>
                <div ref={this.scrollthis} className="List">
                    {
                        this.state.tracks.map((track, key) => {
                            var search =queryString.parse(this.props.location.search).track
                            if (track.artwork_url) {
                                var imgLink = track.artwork_url.replace("large", "t500x500")
                            } else {
                                imgLink = noartwork
                            }
                            return <ReactCSSTransitionGroup
                                key={key}
                                transitionName="example"
                                transitionAppear={true}
                                transitionAppearTimeout={800}
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={300}>
                                <Album
                                    active={this.state.activeIndex}
                                    genre={this.props.genre}
                                    imgLink={imgLink}
                                    isPaused={this.props.isPaused}
                                    ind={key}
                                    onClick={this.handleClick}
                                    ref={this.spinner}
                                    search={search}
                                    track={track}
                                    widget={this.props.widget}
                                    currentTrack={this.props.currentTrack}
                                />

                            </ReactCSSTransitionGroup>;
                        })
                    }

                </div>
            </div>
        );
    }
}

export default Stream


// WEBPACK FOOTER //
// ./src/components/Stream.js